/**
 * @prettier
 */

import React, { useContext, useEffect, useState } from 'react'
import AuthContext from '../../context/auth/AuthContext'
import CategoryListPage from '../ui/CategoryListPage'
import { useFormHandler } from '../../utils/Custom'
import StoreContext from '../../context/store/StoreContext'
import { CardContainer, ListContainer } from '../layout/Containers'
import { PlusIcon } from '../../img/images'
import Drawer from '../input/Drawer'
import { Link } from 'react-router-dom'
import { withComponentLabel } from '../../utils/debug'

const StoresPage = () => {
  const storeContext = useContext(StoreContext)
  const authContext = useContext(AuthContext)

  const { getStores, addStore, clearCurrentStore } = storeContext

  const { loadUser } = authContext

  const [loading, setLoading] = useState(true)
  const [theseStores, setTheseStores] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)

  useEffect(() => {
    const loadStoresList = async () => {
      await loadUser()
      const stores = await getStores()
      setTheseStores(stores)
      clearCurrentStore() // NOTE - if this isn't here, clicking on a store in the list will show the details of the previous store
      setShowDrawer(false)
      setLoading(false)
    }
    loadStoresList()
    // eslint-disable-next-line
  }, [])

  const [changeVal, submitVal, state] = useFormHandler(addStore, { name: '' })

  const storeAdd = async (e) => {
    setLoading(true)
    const newStore = await submitVal(state)
    setTheseStores((prevState) => [...prevState, newStore])
    changeVal({ name: '' })
    setLoading(false)
  }

  const onChange = (e) => {
    e.preventDefault()
    changeVal({ [e.target.name]: e.target.value })
  }

  const handleModalClick = () => {
    setShowDrawer(!showDrawer)
  }

  const addIcon = (
    <PlusIcon
      color="fill-gray-700"
      height="9"
      width="9"
    />
  )

  return (
    <ListContainer>
      <CardContainer>
        {!loading && (
          <>
            <CategoryListPage
              model={theseStores}
              headerString="Stores"
            >
              <Drawer
                addIcon={addIcon}
                handleButtonClick={handleModalClick}
                display={showDrawer}
                action={storeAdd}
                onChange={onChange}
                placeholder="New store name"
              />
              <div>
                {theseStores.length ? (
                  theseStores.map((store, i) => (
                    <Link
                      to={`/stores/${store._id}`}
                      className="flex h-20 border-2 text-gray-700"
                      key={i}
                    >
                      {/* image placeholder */}
                      <div className="h-16 w-16 my-auto mx-3 bg-gray-300"></div>
                      {/* text wrapper */}
                      <div className="flex flex-col mt-2 gap-2 ">
                        <div className="ml-1 text-2xl">{store.name}</div>
                        <div className="flex">
                          <div className="flex items-center mr-1">
                            {/* {secondaryContent} */}
                          </div>
                          <div className="flex items-end text-xs text-gray-600">
                            {/* {secondaryContentText} */}
                          </div>
                        </div>
                      </div>
                    </Link>
                  ))
                ) : (
                  <div className="flex text-gray-600 border-y-2 py-4">
                    <div className="w-full text-center">
                      <div className="text-4xl md:text-6xl">😕</div>
                      <div className="text-xl md:text-2xl">
                        Nothing here yet...
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </CategoryListPage>
          </>
        )}
      </CardContainer>
    </ListContainer>
  )
}

export default withComponentLabel(StoresPage, 'StoresPage')
